<template>
  <div>
    <el-dialog
      :title = "editType == 'edit' ? '编辑' : '新增' "
      :visible.sync = "visible"
      :close-on-click-model="false"
      @close="summaryDailogClose"
      append-to-body
      :width="`${900}px`"
    >
      <el-form ref="form" label-position="right" :model="formChild" :rules="formRules" label-width="120px">
        <el-form-item label="请选择月份" prop="month">
          <el-date-picker v-model="formChild.month" @change="handeTimeChange" type="month" :disabled="editType === 'edit'" value-format="yyyy-MM" size="small" placeholder="请选择月份"></el-date-picker>
        </el-form-item>
        <el-form-item label="结算版本" prop="version">
          <el-select  v-model="formChild.version" size="small"  :disabled="editType === 'edit'" clearable placeholder="请选择结算版本">
            <el-option
              v-for="item in versionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本名称" prop="name">
          <el-input style="width: 520px" v-model="formChild.name" placeholder="请输入简要说明，方便区分多次结算数据"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" icon="el-icon-circle-check" @click="submit">提交</el-button>
        <el-button size="small" type="info" icon="el-icon-circle-close" @click="summaryDailogClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addSettle, update, getMaxVersion } from '@/api/projectSettlement/summary'
import { getLastMonthFormatted } from '@/util/util'
export default {
  props: {
    summaryDailogFlag: {
      type:  Boolean,
      default: false
    },
    editId: {
      type: String,
      default: ''
    },
    editType: {
      type: String,
      default: () => ''
    },
    row: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      formChild: {
        month: '',
        version: 1,
        name: ''
      },
      formRules: {
        month: [{
          required: true, message: '请选择月份', trigger: 'blur'
        }],
        version: [{
          required: true, message: '请选择', trigger: 'change'
        }],
        name: [{
          required: true, message: '请输入版本名称', trigger: 'blur'
        }]
      },
      token: this.$route.query.t || '',
      // 老乐播云数据
      oData: {
        token: this.$route.query.t,
        tid: this.$route.query.tid,
        name: this.$route.query.name
      },
      versionOptions: [{
        value: 1,
        label: 'V1'
      }, {
        value: 2,
        label: 'V2'
      }, {
        value: 3,
        label: 'V3'
      }, {
        value: 4,
        label: 'V4'
      }, {
        value: 5,
        label: 'V5'
      }, {
        value: 6,
        label: 'V6'
      }, {
        value: 7,
        label: 'V7'
      }, {
        value: 8,
        label: 'V8'
      }, {
        value: 9,
        label: 'V9'
      }, {
        value: 10,
        label: 'V10'
      }]
    }
  },
  mounted () {
  },
  methods: {
    // 回填数据
    rewrite() {
      for (let key of Object.keys(this.formChild)) {
        this.formChild[key] = this.row[key];
      }
    },
    // 提交
    submit() {
      this.$refs.form.validate( valid => {
        if (valid) {
          let params = {
            adduser: '',
            month: this.formChild.month,
            version: this.formChild.version,
            name: this.formChild.name
          }
          if(this.editId) {
            params.id = this.editId
          }
          const sumitFun = this.editType == 'edit' ? update : addSettle
          sumitFun(params, this.oData).then(res => {
            if(res.data.code === 200) {
              this.summaryDailogClose()
              this.$emit('submit')
            }
          })
        }
      })
    },
    resetFiles() {
      for (let key of Object.keys(this.formChild)) {
        this.formChild[key] = '';
      }
    },
    summaryDailogClose() {
      this.resetFiles()
      this.$refs.form.clearValidate()
      this.$emit('update:summaryDailogFlag', false)
    },
    // 设置默认的版本号
    getMaxVersion() {
      getMaxVersion({
        month: this.formChild.month
      }).then(res => {
        // console.log('当月最大版本', res)
        if(res.data.code === 200) {
          this.formChild.version = res.data.data + 1
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  watch: {
    summaryDailogFlag() {
      this.visible = this.summaryDailogFlag
    },
    editType (val) {
      if ( val === 'edit') {
        this.rewrite()
      } else if(val === 'add') {
        this.formChild.month = getLastMonthFormatted()
        console.log('add', this.formChild.month)
        this.getMaxVersion()
      }
    },
    'formChild.month' () {
      if(this.editType === 'add') this.getMaxVersion()
    }
  }
}
</script>
<style lang="scss" scoped>

</style>